import UploadImage from '@/components/upload-image/index.vue';
import ProjectService from '../../project.service';
import { errorMessage, successMessage } from '@/utils/message.js';
const debounce = require('lodash.debounce');
export default {
  components: {
    UploadImage
  },
  data() {
    const validateInputValue = (rule, value, callback) => {
      if (this.ruleForm.certificate.inputValue) {
        callback();
      } else {
        callback(new Error('请上传付款凭证'));
      }
    };
    return {
      iframeUrl: '',
      id: '',
      activeNav: 1,
      detail: {},
      ruleForm: {
        certificate: {
          filePaths: [],
          inputValue: null
        },
        remark: ''
      },
      rules: {
        inputValue: [
          { required: true, validator: validateInputValue, trigger: 'change' }
        ]
      },
      actionStatus: 'init'
    };
  },
  created () {
    // 后端防双击
    this.$store.dispatch('generatorClickToken');
    this.id = this.$route.query.projectId;
    if (this.id) {
      this.getContractPaymentDetail();
    }
  },
  methods: {
    changeActiveNav (key) {
      this.activeNav = key;
      // 线上支付
      if(Number(key) === 2) {
        let paymentParams = {
          projectBidCode: this.detail.projectBidCode,
          amount: this.detail.dealAmount,   // 交易金额
          bidNo: this.detail.projectBidCode, // 标的编号
          cashierType: 'PC',   // 收银台类型(PC端/移动端)
          transactionType: 10, // 2 保证金； 10 合同款、履约保证金；12 工程质保金
          acctNo: this.detail.payerAcc // 付款方银行账号
        };
        this.$store.dispatch('onlinePayment', paymentParams).then((res) => {
          console.log(res, '====res');
          this.iframeUrl = res.data.bankNoURL;
        }, error => {
          if (error && error.reason) {
            errorMessage(error.reason);
          }
        });
      }
    },
    getContractPaymentDetail() {
      ProjectService.getContractPaymentDetail(this.id).then(res => {
        if (res && res.code === '0') {
          this.detail = res && res.data;
        }
      });
    },
    uploadImage (event) {
      this.ruleForm.certificate.filePaths = event;
      if (event.length) {
        this.ruleForm.certificate.inputValue = event.length;
      } else {
        this.ruleForm.certificate.inputValue = null;
      }
    },
    previousStep () {
      this.$router.back();
    },
    // 线下支付
    test: debounce(function(){
      if (this.actionStatus === 'ongoing') {return;}
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交支付合同款信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    submit: debounce(function(){
      if (this.actionStatus === 'ongoing') {return;}
      this.actionStatus = 'ongoing';
      ProjectService.contractPayment({
        projectId: this.id,
        remark: this.ruleForm.remark,
        amount: this.detail && this.detail.dealAmount,
        voucherUrls: this.ruleForm.certificate.filePaths.map(item => item.sourceImgUrl)
      }).then(res => {
        if (res && res.code === '0') {
          this.actionStatus = 'success';
          successMessage('提交成功');
          this.previousStep();
        } else if (res && res.reason) {
          this.actionStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.actionStatus = 'failed';
          errorMessage('提交失败');
        }
      }, (error) => {
        this.actionStatus = 'failed';
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('提交失败');
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
